var generateStyle = function generateStyle(componentTheme) {
  return {
    countText: {
      paddingRight: componentTheme.countTextPadding
    },
    newWordCount: {
      textAlign: 'right'
    }
  };
};
export default generateStyle;